var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('v-row',{staticStyle:{"height":"400px","max-width":"unset"},attrs:{"align-content":"center","justify":"center","no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"half-circle-spinner"},[_c('span',{staticClass:"loader"})])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }